import videoIcon from '@insync-students-assets/content-types/fig-s-video.png';
import assessmentIcon from '@insync-students-assets/content-types/fig-s-assessment.png';
import fileIcon from '@insync-students-assets/content-types/fig-file.png';
import linkIcon from '@insync-students-assets/content-types/fig-external-link.png';
import imageIcon from '@insync-students-assets/content-types/fig-external-link.png';
import digitalInteractiveIcon from '@insync-students-assets/content-types/fig-external-link.png';
import { ResourceType } from '@insync-students-lib/services/cms/cms-api.types';
export interface IContentType {
  key: string;
  label: string;
  iconUrl?: string;
}
interface ContentTypeEnum {
  [key: string]: IContentType;
}
export enum ContentType {
  assessment = 'assessment',
  video = 'video',
  file = 'file',
  link = 'link',
  image = 'image',
  digitalInteractive = 'digital-interactive',
}
export enum FileSubTypes {
  thumbnail = 'thumbnail',
  pdf = 'pdf',
}
export const ContentTypesList: ContentTypeEnum = {
  [ResourceType.Video]: {
    key: 'video',
    label: 'Video',
    iconUrl: videoIcon
  },
  [ResourceType.Assessment]: {
    key: 'assessment',
    label: 'Assessment',
    iconUrl: assessmentIcon
  },
  [ResourceType.File]: {
    key: 'file',
    label: 'File',
    iconUrl: fileIcon
  },
  [ResourceType.Link]: {
    key: 'link',
    label: 'Link',
    iconUrl: linkIcon
  },
  [ResourceType.Image]: {
    key: 'image',
    label: 'Image',
    iconUrl: imageIcon
  },
  [ResourceType.DigitalInteractive]: {
    key: 'digital-interactive',
    label: 'Digital Interactive',
    iconUrl: digitalInteractiveIcon
  },
  [ResourceType.Invalid]: {
    key: '',
    label: '',
    iconUrl: '/image-missing'
  }
};
export function getContentTypeFrom(key: string): IContentType {
  return key in ContentTypesList ? ContentTypesList[key] : ContentTypesList[ResourceType.Invalid];
}